<hlm-form-field class="w-full">
  <label hlmLabel [for]="control">
    {{ label }}

    @if (required()) {
      <span class="text-primary">*</span>
    }
  </label>

  <div class="relative h-[136px]">
    <textarea
      hlmInput
      class="h-full w-full resize-none rounded-lg bg-background p-4"
      [id]="control"
      [formControlName]="control"
      [minlength]="formControl.errors?.['minlength']?.requiredLength ?? 0"
      [maxlength]="formControl.errors?.['maxlength']?.requiredLength ?? 250"
      [placeholder]="placeholder"></textarea>

    @if (showWordCounter) {
      <span class="absolute right-3 top-[100px] pt-1 text-xs text-tertiary-foreground">
        {{ (formControl.value || '').length }}/{{ formControl.errors?.['maxlength']?.requiredLength || 250 }}
      </span>
    }
  </div>
  <hlm-error [control]="control" class="text-xs"/>

  @if (hint) {
    <hlm-hint>{{ hint }}</hlm-hint>
  }
</hlm-form-field>
